import React from 'react';
import { Tooltip } from '../Tooltip';

export const Table = ({
  columns,
  odd,
  children,
  className,
  large,
  tooltips = [],
}) => {
  return (
    <div className={`overflow-table ${className}`}>
      <table className={`${odd ? 'odd' : ''}`}>
        <thead>
          <tr>
            {columns.map((c, index) => {
              if (c) {
                return (
                  <th style={{ fontSize: large ? 16 : 12 }} key={c}>
                    {c}
                    {tooltips[index] && (
                      <Tooltip title={tooltips[index]} arrow placement="right">
                        ?
                      </Tooltip>
                    )}
                  </th>
                );
              }
              return <th key={c} className="transparent" aria-label="none" />;
            })}
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  );
};

export const TableRows = ({ columns, odd, className, large, line }) => {
  return (
    <div className={`overflow-table ${className}`}>
      <table className={`${odd ? 'odd' : ''}`}>
        <thead>
          <tr>
            {columns.map((c) => {
              if (c) {
                return (
                  <th style={{ fontSize: large ? 16 : 12 }} key={c}>
                    {c}
                  </th>
                );
              }
              return <th key={c} className="transparent" aria-label="none" />;
            })}
          </tr>
        </thead>
        <tbody>
          <tr>
            {line.map((l) => {
              if (l) {
                return <td key={l}>{l}</td>;
              }
              return null;
            })}
          </tr>
        </tbody>
      </table>
    </div>
  );
};
